import React from "react"
import Layout from "../components/layout"
import Footer from "../components/Footer"
import Seo from "../components/seo"
import PartneringGetform from "../components/forms/PartneringGetform"

export default function PartneringPage() {
  const heroHeading = "Newbury Pharmaceuticals are actively looking to acquire and license medicines for the Nordic"
  const heroSubheading = "Your Local Champion in the Nordic"
  const reasonsHeading = "Strong reasons to partner with Newbury"
  const reasons = [
    "We offer a pragmatic partnership with focus on growing the business in a compliant manner.",
    "We offer fast access to customers and can cover all Nordic markets with disciplines relating to pricing, reimbursement, distribution, S&M.",
    "We focus on growing sales to develop a mutual long-term beneficial partnership based on a hassle-free and full-service set-up.",
    "We are a lean organization but with all the required resources and very experienced manpower to manage your products best possible.",
    "We have a strong track record and background from managing branded innovative products and exchangeable business in tenders and pricing lists.",
    "We utilize our strengths within Regulatory, PV, Quality, Supply Chain, Tendering, Finance and management to optimise the business."
  ]

  return (
    <Layout>
      <Seo
        title="Partnering"
        description="Are you a pharmaceutical manufacturer looking for a reliable partner in the Nordics? We are now scaling up for future growth and are looking to further strengthen our portfolio in areas like biologic treatments, peptides and long acting injectables."
      />

      {/* Hero Section  */}
      <div className="bg-primary text-white py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-6">
            {heroHeading}
          </h1>
          <p className="text-xl md:text-2xl font-light">
            {heroSubheading}
          </p>
        </div>
      </div>

      {/* Reasons Section */}
      <div className="max-w-4xl mx-auto py-16 md:py-24 px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary">
          {reasonsHeading}
        </h2>

        <div className="space-y-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex-shrink-0 mt-1">
                <svg
                  className="w-6 h-6 text-primary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
                {reason}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="py-16 md:py-24">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Get in Touch
          </h2>
          <p className="text-center text-lg text-gray-600 mb-12">
            Interested in partnering with us? Fill out the form below and we'll get back to you.
          </p>
          <PartneringGetform />
        </div>
      </div>

      <Footer />
    </Layout>
  )
}
